import React, { useState } from 'react'
import { NavLink } from 'reactstrap';
import { Maximize } from 'react-feather';
import { Href } from '../../../constants';

import { useEffect } from "react";

const FullScreen = () => {
    const [fullScreen, setFullScreen] = useState(false);

    const fullScreenHandler = async (isFullScreen: boolean) => {
        try {
            setFullScreen(isFullScreen);

            if (isFullScreen) {
                if (!document.fullscreenElement && document.documentElement.requestFullscreen) {
                    await document.documentElement.requestFullscreen();
                }
            } else {
                if (document.fullscreenElement && document.exitFullscreen) {
                    await document.exitFullscreen();
                }
            }
        } catch (err) {
            console.error("Fullscreen error:", err);
        }
    };

    useEffect(() => {
        // Cleanup fullscreen on unmount or route change
        return () => {
            if (document.fullscreenElement) {
                document.exitFullscreen().catch(() => {});
            }
        };
    }, []);

    return (
        <li onClick={() => fullScreenHandler(!fullScreen)}>
            <NavLink href={Href}>
                <Maximize className="svg-color" />
            </NavLink>
        </li>
    );
};


export default FullScreen;